import { LocalizedText } from "../../components/LocalizedText";
import * as React from 'react';
import useTranslator from '../../hooks/translate';
import { getItemName } from '../../resources/Items';
import { IItem } from '../../slices/inventorySlice';
import { LineBreak } from './components/LineBreak';
import { BaseInfo } from './components/BaseInfo';
import { CDNImage } from '../../components/Elements/Image';

export const PetInfo: React.FC<{ item: IItem }> = ({ item }) => {
  const t = useTranslator();
  const { iid } = item;
  const props = item.props;
  const name = getItemName(iid);
  const level = item.props ? item.props.level || 0 : 0;
  // Only gacha preview items carry this field. Owned pets show learned skills.
  const learnable = props?.previewLearnableSkills;
  const previewOnly = !!props?.previewLearnableSkills;

  return (
    <>
      <div style={{ color: 'teal' }}>
        <LocalizedText text={name} /> + {level}
      </div>
      <BaseInfo item={item}></BaseInfo>
      <LineBreak />

      {!previewOnly && <><div><LocalizedText text={"Aura:"} /><LocalizedText text={' '} />
        {(props?.skills?.aura ?? []).map((id: number) => (
          <CDNImage key={id} src={`icons/skills/${id}.png`} style={{ marginRight: 5, width: 24, height: 24, objectFit: 'contain', verticalAlign: 'middle' }} />
        ))}
      </div>


      <div><LocalizedText text={"Aid:"} /><LocalizedText text={' '} />
        {(props?.skills?.active ?? []).map((id: number) => (
          <CDNImage key={id} src={`icons/skills/${id}.png`} style={{ marginRight: 5, width: 24, height: 24, objectFit: 'contain', verticalAlign: 'middle' }} />
        ))}
      </div>

      <div><LocalizedText text={"Passive:"} /><LocalizedText text={' '} />
        {(props?.skills?.passive ?? []).map((id: number) => (
          <CDNImage key={id} src={`icons/skills/${id}.png`} style={{ marginRight: 5, width: 24, height: 24, objectFit: 'contain', verticalAlign: 'middle' }} />
        ))}
      </div></>}
      {learnable && <section aria-label="สกิลที่สามารถเรียนรู้ได้" style={{ marginTop: 8 }}>
        <div style={{ color: '#ffd477', marginBottom: 4 }}>สกิลที่สามารถเรียนรู้ได้</div>
        <div style={{ color: '#ddd', fontSize: 11, marginBottom: 8 }}>ตัวอย่างสกิลที่เรียนได้ ไม่ใช่สกิลที่ได้รับทันที และไม่ได้เรียนได้ทั้งหมดพร้อมกัน</div>
        {(['aura', 'active', 'passive'] as const).map((key, index) => <div key={key} style={{ marginBottom: 8 }}>
          <strong>{['ออร่า', 'ช่วยเหลือ', 'ติดตัว'][index]}:</strong>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,minmax(0,1fr))', gap: 4, marginTop: 4 }}>
            {(learnable[key] ?? []).map((id: number) => <div key={id} style={{ display: 'flex', alignItems: 'center', gap: 3, fontSize: 10, overflowWrap: 'anywhere' }}>
              <CDNImage src={`icons/skills/${id}.png`} style={{ width: 22, height: 22, objectFit: 'contain', flexShrink: 0 }} />
              <span>{t(`skill__${id}--name`)}</span>
            </div>)}
          </div>
          {!learnable[key]?.length && <span style={{ color: '#aaa', fontSize: 11 }}> ไม่มีสกิลที่เปิดให้เรียนในหมวดนี้</span>}
        </div>)}
      </section>}
    </>
  );
};
